export default [
  {
    path: '/student-scoring-entries',
    name: 'student-scoring-entry',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-scoring-entry/index.vue')
  },
  {
    path: '/student-scoring-entries/create',
    name: 'student-scoring-entry-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-scoring-entry/create.vue')
  }
]
